// apps/client/src/world/objects/rock.ts — rocks and stumps join one instanced batch per catalog id
import { InstanceProxy, modelTemplate, type ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['rock', 'stump'],
  async build(obj, ctx) { return new InstanceProxy(obj.catalogId, await modelTemplate(ctx.assets, obj.catalogId)); },
};
